import type { YearSummary } from '../../../../entities/summary/index.js';
import { List, ListItem } from '../../../../shared/ui/index.js';

type WithoutForecastProps = {
  summary: YearSummary;
};

export const WithoutForecast = ({ summary }: WithoutForecastProps) => {
  if (summary.withoutForecast.length === 0) {
    return null;
  }

  return (
    <List
      header="Без прогнозу"
      footer="Змінна сума без жодної оплати: після першої оплати з'явиться оцінка."
    >
      {summary.withoutForecast.map((payment) => (
        <ListItem key={payment.paymentId} title={payment.name} subtitle="ще жодної оплати" />
      ))}
    </List>
  );
};
